import camelize from 'camelcase-keys-deep';

export default class MandateBase {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  document() {
    return this.env().Document.getById(this.documentId);
  }

  mandate() {
    return this.env().Mandate.getById(this.mandateId);
  }

  lots() {
    return this.env().Lot.findAllBy('mandateBaseId', this.id);
  }
}
